import { DatabaseRecord } from "../repos/table.repo";

export enum PaymentOutboxStatus {
    Pending = 0,
    Processing = 1,
    Done = 2,
    Dead = 3,
}

export const PAYMENT_OUTBOX_CHANNELS = ["Vietinbank", "VNPayQR"] as const;
export type PaymentOutboxChannel = (typeof PAYMENT_OUTBOX_CHANNELS)[number];

export interface PaymentOutboxItemModel extends DatabaseRecord {
    bankTransactionId: string | null;
    channel: string;
    orderId: string | null;
    amount: number;
    requestId: string | null;
    status: number;
    statusName: string;
    attemptCount: number;
    lastError: string | null;
    createdAt: string | null;
    processedAt: string | null;
    nextAttemptAt: string | null;
    durationMs: number | null;
    waterFactoryId: string | null;
    waterFactoryName: string | null;
    invoiceCode: number | null;
    invoiceStatus: string | null;
}

export interface PaymentOutboxStatsModel {
    pending: number;
    processing: number;
    done: number;
    dead: number;
    oldestPendingAgeSeconds: number | null;
    topDeadError: string | null;
    useOutboxQueue: boolean;
    usePersistentStore: boolean;
    workerEnabled: boolean;
    batchSize: number;
    maxAttempts: number;
    healthWarning: string | null;
}

export interface PaymentOutboxRetryResult {
    retried: number;
    requested: number;
    skipped: number;
}

export class PaymentOutboxItemModelFactory {
    static getEmpty(): PaymentOutboxItemModel {
        return {
            id: "",
            bankTransactionId: null,
            channel: "",
            orderId: null,
            amount: 0,
            requestId: null,
            status: PaymentOutboxStatus.Pending,
            statusName: "Pending",
            attemptCount: 0,
            lastError: null,
            createdAt: null,
            processedAt: null,
            nextAttemptAt: null,
            durationMs: null,
            waterFactoryId: null,
            waterFactoryName: null,
            invoiceCode: null,
            invoiceStatus: null,
        };
    }
}
